var Curriculog = Curriculog || {};

Curriculog.UserRolesForFilter = (function ($, _, Backbone, UserRolesForFilter) {

    UserRolesForFilter = Curriculog.CurriculogCollection.extend({
        url: 'rest/userrolesfilter',
        model: Curriculog.UserRoleForFilter,
        comparator: function(model) {
            return model.get('name');
        }
    });
    return UserRolesForFilter;

})($, _, Backbone, Curriculog.UserRolesForFilter || {});
